(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('tests', tests);

    /* @ngInject */
    function tests() {
        var directive = {
            bindToController: true,
            templateUrl: 'tests.tpl',
            controller: testsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function testsController ($scope,$http) {
        /*
        $scope.vm.formModel = {};
        $scope.vm.fieldKey = '';
        $scope.vm.fieldPath = '';
        */
        $scope.upload = function() {
            var file = angular.element('[name="media-file"]')[0].files[0];
            console.log(file);

            var fd = new FormData();
            fd.append('media-file', file, file.name);
            fd.append('action', 'test_action');
            fd.append('file-name', 'media-file');
            $http.post(ajaxurl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function(response) {
                console.log(response);
            });
        };
    }

})();